import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Message from "../../config/message_v2.js";
import MessageV1 from "../../config/message.js";

export default {
  ValidateForm(form) {
    if (!form.Asset) {
      toast.warning(Message.ERROR.EMPTY.ASSET);
      return false;
    } else if (!form.Service) {
      toast.warning(Message.ERROR.EMPTY.MAINTENANCE);
      return false;
    } else if (!form.Description) {
      toast.warning(Message.ERROR.EMPTY.DESCRIPTION);
      return false;
    }
    return true;
  },
  ValidateFormMoveAsset(form) {
    if (!form.Site) {
      toast.warning(MessageV1.ERROR.MODEL.TRACKING.FORM.VALIDATION.SITE_EMPTY);
      return false;
    } else if (!form.Location) {
      toast.warning(
        MessageV1.ERROR.MODEL.TRACKING.FORM.VALIDATION.LOCATION_EMPTY
      );
      return false;
    }
    return true;
  },
  ValidateFormAcceptReassign(form) {
    if (!form.Site) {
      toast.warning(MessageV1.ERROR.MODEL.TRACKING.FORM.VALIDATION.SITE_EMPTY);
      return false;
    } else if (!form.Location) {
      toast.warning(
        MessageV1.ERROR.MODEL.TRACKING.FORM.VALIDATION.LOCATION_EMPTY
      );
      return false;
    }
    return true;
  }
};



// WEBPACK FOOTER //
// ./src/App/home/helper/form.js